import { ALL_PRODUCT_TYPES } from "constants/chart.constants";

const allProductTypes = Object.values(ALL_PRODUCT_TYPES);

/**
 * Resolves a product display label to its internal key for consistent storage.
 * E.g., "C₅₊" → "C5", "Oil, Cond, C₅₊" → "Oil+Cond+C5", "CO₂ Inj" → "CO2 Inj"
 *
 * Special case: "Oil + Cond" is stored as "Oil" for backward compatibility.
 */
export function getProductKey(productLabel: string): string {
  if (productLabel === "Oil + Cond") return "Oil";

  const productEntry = allProductTypes.find((p) => p.label === productLabel);
  return productEntry?.key ?? productLabel;
}
